import React, { Component } from "react";
import "../css/victory.css";
import { TweenMax, Expo, Back } from "gsap/TweenMax";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { NavLink } from "react-router-dom";
import hikari from "../assets/hikari.gif";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  input: {
    display: "none"
  }
});

class Victory extends Component {
  handleClick = e => {
    let duration = 0.3;
    let delay = 0.08;
    TweenMax.to(e.target, duration, { scaleY: 1.6, ease: Expo.easeOut });
    TweenMax.to(e.target, duration, {
      scaleX: 1.2,
      scaleY: 1,
      ease: Back.easeOut,
      easeParams: [3],
      delay: delay
    });
    TweenMax.to(e.target, duration * 1.25, {
      scaleX: 1,
      scaleY: 1,
      ease: Back.easeOut,
      easeParams: [6],
      delay: delay * 3
    });
  };

  render() {
    return (
      <div className={this.props.classes.root}>
        {" "}
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={24}
          className="victory"
        >
          <Grid item xs={12} sm={6} lg={4}>
            <div className="title">
              <h1>VICTORY</h1>
              <h2>Congratulations !</h2>
              <div className="button" onMouseOver={this.handleClick}>
                <NavLink to="/">
                  <p>Go Home</p>
                </NavLink>
              </div>
            </div>
          </Grid>
          <div>
            <img className="hikari_img" src={hikari} alt='logo hikari' />
          </div>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Victory);
